import {
  Uninstalled,
  UninstallResponse
} from '@/modules/utilities/uninstallApp/types/UninstallForm.ts'
import gestionApiService from '@/core/services/gestionApiService.ts'

export default class UninstallAppService {
  static async getUninstallAppData(
    registersNumber: string,
    supplierId: string,
    signal?: AbortSignal
  ): Promise<UninstallResponse> {
    return gestionApiService.httpGET<UninstallResponse>(
      `/devices/${registersNumber}/uninstall-app-data?supplierId=${supplierId}`,
      { signal }
    )
  }

  static async setUninstallApp(
    registersNumber: string,
    supplierId: string,
    signal?: AbortSignal
  ): Promise<Uninstalled> {
    return gestionApiService.httpPOST<Uninstalled>(
      `/devices/${registersNumber}/uninstall-app?supplierId=${supplierId}`,
      {},
      { signal }
    )
  }
}
